<script lang="ts" context="module">
  let projectId = 0;
  export function getProjectId() {
    return projectId;
  }
  function setProjectId(newProjectId: number) {
    projectId = newProjectId;
  }
</script>
<script lang="ts">
  import { onDestroy, onMount } from 'svelte';
    import IconButton from "../components/buttons/IconButton.svelte";
    import DividedView from "../components/DividedView.svelte";
    import EditorWindow from "../components/editor/EditorWindow.svelte";
    import NoDistrationIcon from "../components/icons/NoDistrationIcon.svelte";
    import VersionControlIcon from "../components/icons/VersionControlIcon.svelte";
    import Tree from "../components/tree/Tree.svelte";
    import VersionControlOverlay from "../versionControl/VersionControlOverlay.svelte";

    export let params: { projectId: number };

    let showVersionControlOverlay = false;

    onMount(() => {
      setProjectId(params.projectId);
    });

    onDestroy(() => {
        document.body.classList.remove("no-distraction");
        setProjectId(0);
    });
</script>

<div class="ProjectEditor">
    <DividedView percentage={30} id="ProjectEditor">
        <Tree projectId={params.projectId} slot="window1" />
        <div slot="window2">
            <EditorWindow projectId={params.projectId} />
        </div>
    </DividedView>
    <div />
</div>
{#if showVersionControlOverlay}
    <VersionControlOverlay projectId={params.projectId} closeCallback={() => {
        showVersionControlOverlay = false;
    }}/>
{/if}
<div class="DistractionSwitch">
    <IconButton
        icon={NoDistrationIcon}
        title="Distration free mode"
        onClick={() => {
            if (document.body.classList.contains("no-distraction")) {
                document.body.classList.remove("no-distraction");
            } else {
                document.body.classList.add("no-distraction");
            }
        }}
    />
</div>
<div class="GitSwitch">
    <IconButton
        icon={VersionControlIcon}
        title="Version control"
        onClick={() => {
            showVersionControlOverlay = !showVersionControlOverlay;
        }}
    />
</div>

<style type="text/scss">
    .ProjectEditor {
        display: flex;
        height: 100vh;
    }
    .DistractionSwitch {
        position: fixed;
        bottom: 10px;
        left: 10px;
    }
    .GitSwitch {
        position: fixed;
        bottom: 10px;
        left: 44px;
    }
</style>
